export default __webpack_public_path__ + "static/media/household-keymap-3.6205287e.png";